import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FailedToNegotiateWithServerError } from '@microsoft/signalr/dist/esm/Errors';
import { DxPopupComponent } from 'devextreme-angular';

export class SessionDelay{
  AptId : number=-1;  
  preSessionDelay :number =3;
  postSessionDelay :number =3;
  save : boolean=false;
}

@Component({
  selector: 'app-edit-session-delays',
  templateUrl: './edit-session-delays.component.html',
  styleUrls: ['./edit-session-delays.component.css']
})
export class EditSessionDelaysComponent implements OnInit {

  constructor() { }
  
  @ViewChild(DxPopupComponent) popup: DxPopupComponent;
  @Output() CloseDlg: EventEmitter<SessionDelay> = new EventEmitter<SessionDelay>();
  sessionDelay:SessionDelay = new SessionDelay();

  ngOnInit(): void {
  }

  OkButtonOptions = {
    name: 'btnOK',
    text: 'Save',
    onClick: this.btnOK_Click.bind(this),
  };

  CancelButtonOptions = {
    text: 'Cancel',
    onClick: this.btnCancel.bind(this)
  };  
    
  public show(sessionDelay: SessionDelay) {
    this.sessionDelay = sessionDelay;
    this.popup.visible = true;
  }

  btnOK_Click(e) {
    this.sessionDelay.save=true;
    this.CloseDialog();
  }

  btnCancel(e) {
    this.sessionDelay.save=false;
    this.CloseDialog();
  }

  CloseDialog() {
    this.CloseDlg.emit(this.sessionDelay);    
    this.popup.visible = false;
  }
}

